export default `float d = 0;
  p.z+=.8;
  for(int i=0;++i<10;)
    p.y-=clamp(p.y,.0,.1),
    p=abs(p),
    p*=rotate3D(.4,vec3(1.0,.2,-1.0)),
    p*=1.1;
  d=length(p)-.02;
  d*=.39;
  return d;
}`